import { render, staticRenderFns } from "./RelatedJobs.vue?vue&type=template&id=5a587993&scoped=true&"
import script from "./RelatedJobs.vue?vue&type=script&lang=ts&"
export * from "./RelatedJobs.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedJobs.vue?vue&type=style&index=0&id=5a587993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a587993",
  null
  
)

export default component.exports